export class StateListsModel {
    constructor() {
        this.countryId = "";
        this.stateId = "";
        this.stateName = "";
    }
}
export default class StateLists extends StateListsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
